/* eslint-disable */ /** Are we currently running in a development environment. */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var IS_DEV = process.env.NODE_ENV === "development";
/** Dev escape hatch for overriding the base URL. */ var BASE_URL = window.__BASE_URL__ || "";
// todo(b/129357862): Deprecate this after .NET core go-live.
/** The legacy header name used for sending the CSRF form token. */ var LEGACY_XSRF_HEADER_TOKEN_NAME = "__RequestVerificationToken";
// todo(b/129357862): Make this only load from Webpack DefinePlugin.
// todo(b/129357862): Change names for this to "X-XSRF-TOKEN" back end.
/** The header name used for sending the CSRF form token. */ var XSRF_HEADER_TOKEN_NAME = "X-XSRF-TOKEN";
/** The JS readable XSRF-TOKEN that should be sent as X-XSRF-TOKEN header. */ var XSRF_TOKEN_COOKIE_NAME = "XSRF-TOKEN";
import { equalsCaseInsensitive } from "@kaggle/core";
import fetch from "isomorphic-fetch";
import Cookies from "js-cookie";
import { BucketRateLimiter } from "./rateLimiting/BucketRateLimiter";
import { featureFlags } from "./featureFlags";
import { logger } from "./analytics/logger";
var rateLimiter = null;
var hasBeenRateLimited = false;
var _clientRpcRateLimit;
var rateLimitQps = parseInt((_clientRpcRateLimit = featureFlags.clientRpcRateLimit) !== null && _clientRpcRateLimit !== void 0 ? _clientRpcRateLimit : "", 10);
if (!isNaN(rateLimitQps) && rateLimitQps > 0) {
    rateLimiter = new BucketRateLimiter(rateLimitQps, rateLimitQps, function(rpc, tokensRemaining) {
        // Track an event the first time any RPC is rate-limited.
        if (!hasBeenRateLimited) {
            hasBeenRateLimited = true;
            logger.report("telemetry", "rpc-rate-limited", {
                rpc: rpc,
                tokensRemaining: tokensRemaining
            });
        }
    });
}
function assertRateLimitNotReached(route) {
    // Throw an error if the rate limit for this RPC is exceeded.
    if (rateLimiter !== null && !rateLimiter.canCall(route)) {
        throw new CanonicalError("The RPC ".concat(route, " was rate-limited."), CanonicalErrorCode.RESOURCE_EXHAUSTED);
    }
}
var google = {
    rpc: {
        Code: {
            // Not an error; returned on success
            //
            // HTTP Mapping: 200 OK
            OK: "ok",
            // The operation was cancelled, typically by the caller.
            //
            // HTTP Mapping: 499 Client Closed Request
            CANCELLED: "cancelled",
            // Unknown error.  For example, this error may be returned when
            // a `Status` value received from another address space belongs to
            // an error space that is not known in this address space.  Also
            // errors raised by APIs that do not return enough error information
            // may be converted to this error.
            //
            // HTTP Mapping: 500 Internal Server Error
            UNKNOWN: "unknown",
            // The client specified an invalid argument.  Note that this differs
            // from `FAILED_PRECONDITION`.  `INVALID_ARGUMENT` indicates arguments
            // that are problematic regardless of the state of the system
            // (e.g., a malformed file name).
            //
            // HTTP Mapping: 400 Bad Request
            INVALID_ARGUMENT: "invalidArgument",
            // The deadline expired before the operation could complete. For operations
            // that change the state of the system, this error may be returned
            // even if the operation has completed successfully.  For example, a
            // successful response from a server could have been delayed long
            // enough for the deadline to expire.
            //
            // HTTP Mapping: 504 Gateway Timeout
            DEADLINE_EXCEEDED: "deadlineExceeded",
            // Some requested entity (e.g., file or directory) was not found.
            //
            // Note to server developers: if a request is denied for an entire class
            // of users, such as gradual feature rollout or undocumented allowlist,
            // `NOT_FOUND` may be used. If a request is denied for some users within
            // a class of users, such as user-based access control, `PERMISSION_DENIED`
            // must be used.
            //
            // HTTP Mapping: 404 Not Found
            NOT_FOUND: "notFound",
            // The entity that a client attempted to create (e.g., file or directory)
            // already exists.
            //
            // HTTP Mapping: 409 Conflict
            ALREADY_EXISTS: "alreadyExists",
            // The caller does not have permission to execute the specified
            // operation. `PERMISSION_DENIED` must not be used for rejections
            // caused by exhausting some resource (use `RESOURCE_EXHAUSTED`
            // instead for those errors). `PERMISSION_DENIED` must not be
            // used if the caller can not be identified (use `UNAUTHENTICATED`
            // instead for those errors). This error code does not imply the
            // request is valid or the requested entity exists or satisfies
            // other pre-conditions.
            //
            // HTTP Mapping: 403 Forbidden
            PERMISSION_DENIED: "permissionDenied",
            // The request does not have valid authentication credentials for the
            // operation.
            //
            // HTTP Mapping: 401 Unauthorized
            UNAUTHENTICATED: "unauthenticated",
            // Some resource has been exhausted, perhaps a per-user quota, or
            // perhaps the entire file system is out of space.
            //
            // HTTP Mapping: 429 Too Many Requests
            RESOURCE_EXHAUSTED: "resourceExhausted",
            // The operation was rejected because the system is not in a state
            // required for the operation's execution.  For example, the directory
            // to be deleted is non-empty, an rmdir operation is applied to
            // a non-directory, etc.
            //
            // Service implementors can use the following guidelines to decide
            // between `FAILED_PRECONDITION`, `ABORTED`, and `UNAVAILABLE`:
            //  (a) Use `UNAVAILABLE` if the client can retry just the failing call.
            //  (b) Use `ABORTED` if the client should retry at a higher level
            //      (e.g., when a client-specified test-and-set fails, indicating the
            //      client should restart a read-modify-write sequence).
            //  (c) Use `FAILED_PRECONDITION` if the client should not retry until
            //      the system state has been explicitly fixed.  E.g., if an "rmdir"
            //      fails because the directory is non-empty, `FAILED_PRECONDITION`
            //      should be returned since the client should not retry unless
            //      the files are deleted from the directory.
            //
            // HTTP Mapping: 400 Bad Request
            FAILED_PRECONDITION: "failedPrecondition",
            // The operation was aborted, typically due to a concurrency issue such as
            // a sequencer check failure or transaction abort.
            //
            // See the guidelines above for deciding between `FAILED_PRECONDITION`,
            // `ABORTED`, and `UNAVAILABLE`.
            //
            // HTTP Mapping: 409 Conflict
            ABORTED: "aborted",
            // The operation was attempted past the valid range.  E.g., seeking or
            // reading past end-of-file.
            //
            // Unlike `INVALID_ARGUMENT`, this error indicates a problem that may
            // be fixed if the system state changes. For example, a 32-bit file
            // system will generate `INVALID_ARGUMENT` if asked to read at an
            // offset that is not in the range [0,2^32-1], but it will generate
            // `OUT_OF_RANGE` if asked to read from an offset past the current
            // file size.
            //
            // There is a fair bit of overlap between `FAILED_PRECONDITION` and
            // `OUT_OF_RANGE`.  We recommend using `OUT_OF_RANGE` (the more specific
            // error) when it applies so that callers who are iterating through
            // a space can easily look for an `OUT_OF_RANGE` error to detect when
            // they are done.
            //
            // HTTP Mapping: 400 Bad Request
            OUT_OF_RANGE: "outOfRange",
            // The operation is not implemented or is not supported/enabled in this
            // service.
            //
            // HTTP Mapping: 501 Not Implemented
            UNIMPLEMENTED: "unimplemented",
            // Internal errors.  This means that some invariants expected by the
            // underlying system have been broken.  This error code is reserved
            // for serious errors.
            //
            // HTTP Mapping: 500 Internal Server Error
            INTERNAL: "internal",
            // The service is currently unavailable.  This is most likely a
            // transient condition, which can be corrected by retrying with
            // a backoff.
            //
            // See the guidelines above for deciding between `FAILED_PRECONDITION`,
            // `ABORTED`, and `UNAVAILABLE`.
            //
            // HTTP Mapping: 503 Service Unavailable
            UNAVAILABLE: "unavailable",
            // Unrecoverable data loss or corruption.
            //
            // HTTP Mapping: 500 Internal Server Error
            DATA_LOSS: "dataLoss"
        }
    }
};
export function getAntiForgeryToken() {
    var antiForgeryToken = Cookies.get(XSRF_TOKEN_COOKIE_NAME);
    if (!antiForgeryToken) {
        throw new Error("An anti-forgery token could not be found.");
    }
    return antiForgeryToken;
}
var createBodyJson = function(body) {
    // note that this function assumes a content-type = 'application/json'
    if (body) {
        return JSON.stringify(body);
    }
    return "{}";
};
var processMiniProfilerHeaders = function(response) {
    var miniprofilerHeaders = response.headers.get("X-MiniProfiler-Ids");
    if (typeof MiniProfiler !== "undefined" && (miniprofilerHeaders === null || miniprofilerHeaders === void 0 ? void 0 : miniprofilerHeaders.length)) {
        try {
            MiniProfiler.fetchResults(JSON.parse(miniprofilerHeaders));
        } catch (e) {
            console.error("Failed to parse mini-profiler header", miniprofilerHeaders);
        }
    }
};
var appendRequestHeaders = function(headers, options) {
    var ref;
    var headersToAppend = (ref = options === null || options === void 0 ? void 0 : options.headers) !== null && ref !== void 0 ? ref : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = headersToAppend[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _slicedToArray(_step.value, 2), name = _value[0], value = _value[1];
            headers.append(name, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var fetchRequestWorker = function() {
    var _ref = _asyncToGenerator(function(requestWireFormat, responseWireFormat, route, requestBody, requestOptions) {
        var url, antiForgeryToken, headers, credentials, requestBodyInWireFormat, bodyJson, response, e, generalResponse, e1, ref, errors, ref1, errorCode, errorMessage, errorDetails;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "".concat(BASE_URL, "/requests/").concat(route);
                    antiForgeryToken = getAntiForgeryToken();
                    headers = new Headers();
                    headers.set(LEGACY_XSRF_HEADER_TOKEN_NAME, antiForgeryToken);
                    headers.set(XSRF_HEADER_TOKEN_NAME, antiForgeryToken);
                    headers.set("Content-Type", "application/json");
                    headers.set("Accept", "application/json");
                    appendRequestHeaders(headers, requestOptions);
                    credentials = IS_DEV ? "include" : "same-origin";
                    requestBodyInWireFormat = requestWireFormat.toJson(requestBody);
                    bodyJson = requestBodyInWireFormat ? createBodyJson(requestBodyInWireFormat) : "{}";
                    assertRateLimitNotReached(route);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(url, {
                            headers: headers,
                            credentials: credentials,
                            body: bodyJson,
                            method: "POST"
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    console.error("Fetch error:", e);
                    throw e;
                case 4:
                    processMiniProfilerHeaders(response);
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        response.json()
                    ];
                case 6:
                    generalResponse = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 7:
                    e1 = _state.sent();
                    throw new Error("Command handler response not valid JSON");
                case 8:
                    if (generalResponse.wasSuccessful) {
                        if (generalResponse.result) {
                            return [
                                2,
                                responseWireFormat.fromJson(generalResponse.result)
                            ];
                        }
                        return [
                            2,
                            generalResponse.result
                        ];
                    } else if (generalResponse.wasSuccessful === false) {
                        ;
                        errors = generalResponse.errors;
                        ;
                        errorCode = (ref1 = generalResponse === null || generalResponse === void 0 ? void 0 : (ref = generalResponse.error) === null || ref === void 0 ? void 0 : ref.code) !== null && ref1 !== void 0 ? ref1 : CanonicalErrorCode.INTERNAL;
                        errorMessage = generalResponse.error && generalResponse.error.message || errors[0] || (errorCode === CanonicalErrorCode.OK ? "" : "Internal");
                        errorDetails = generalResponse.error && generalResponse.error.details;
                        throw new CanonicalError(errorMessage, errorCode, errorDetails);
                    }
                    throw new Error("Command handler response had unexpected shape: ".concat(JSON.stringify(Object.keys(generalResponse))));
            }
        });
    });
    return function fetchRequestWorker(requestWireFormat, responseWireFormat, route, requestBody, requestOptions) {
        return _ref.apply(this, arguments);
    };
}();
function fetchProto3JsonWorker(requestWireFormat, responseWireFormat, route, requestBody) {
    return _fetchProto3JsonWorker.apply(this, arguments);
}
function _fetchProto3JsonWorker() {
    _fetchProto3JsonWorker = _asyncToGenerator(function(requestWireFormat, responseWireFormat, route, requestBody) {
        var requestBodyInWireFormat, bodyJson, responseJson, responseMessage;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    requestBodyInWireFormat = requestWireFormat.toJson(requestBody);
                    bodyJson = requestBodyInWireFormat ? createBodyJson(requestBodyInWireFormat) : "{}";
                    return [
                        4,
                        fetchProto3JsonRaw(route, bodyJson)
                    ];
                case 1:
                    responseJson = _state.sent();
                    responseMessage = responseWireFormat.fromJson(responseJson);
                    return [
                        2,
                        responseMessage
                    ];
            }
        });
    });
    return _fetchProto3JsonWorker.apply(this, arguments);
}
function sendRequest(route, requestBody) {
    return _sendRequest.apply(this, arguments);
}
function _sendRequest() {
    _sendRequest = _asyncToGenerator(function(route, requestBody) {
        var url, antiForgeryToken, headers, credentials, bodyJson, response, e;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "".concat(BASE_URL, "/api/i/").concat(route);
                    antiForgeryToken = getAntiForgeryToken();
                    headers = new Headers();
                    headers.set(XSRF_HEADER_TOKEN_NAME, antiForgeryToken);
                    headers.set("Content-Type", "application/json");
                    headers.set("Accept", "application/json");
                    credentials = IS_DEV ? "include" : "same-origin";
                    bodyJson = requestBody !== null && requestBody !== void 0 ? requestBody : "{}";
                    assertRateLimitNotReached(route);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(url, {
                            headers: headers,
                            credentials: credentials,
                            body: bodyJson,
                            method: "POST"
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    console.error("Fetch error:", e);
                    throw e;
                case 4:
                    processMiniProfilerHeaders(response);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return _sendRequest.apply(this, arguments);
}
function buildCanonicalError(responseJson) {
    var ref;
    var error = responseJson.error;
    var _message;
    var message = (_message = error.message) !== null && _message !== void 0 ? _message : (ref = responseJson.errors) === null || ref === void 0 ? void 0 : ref[0];
    return new CanonicalError(message, getCanonicalErrorCodeFromProto3Enum(error.status), error.details, responseJson);
}
// Sends and receives the request using the raw wire format (no mapping)
export function fetchProto3JsonRaw(route, requestBody) {
    return _fetchProto3JsonRaw.apply(this, arguments);
}
function _fetchProto3JsonRaw() {
    _fetchProto3JsonRaw = _asyncToGenerator(function(route, requestBody) {
        var response, responseJson;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        sendRequest(route, requestBody)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    responseJson = _state.sent();
                    if (!response.ok) {
                        throw buildCanonicalError(responseJson);
                    }
                    return [
                        2,
                        responseJson
                    ];
            }
        });
    });
    return _fetchProto3JsonRaw.apply(this, arguments);
}
/**
 * Creates a strongly typed fetch function for requests.
 * @param opts options to use on the request.
 */ export function createRequestClient(requestWireFormat, responseWireFormat, route) {
    return function(req, opts) {
        return fetchRequestWorker(requestWireFormat, responseWireFormat, route, req, opts);
    };
}
// Creates a strongly typed (proto3 JSON) fetch function for requests.
export function createClient(requestWireFormat, responseWireFormat, route) {
    return function(req) {
        return fetchProto3JsonWorker(requestWireFormat, responseWireFormat, route, req);
    };
}
export function fetchRawString(route, requestBody) {
    return _fetchRawString.apply(this, arguments);
}
function _fetchRawString() {
    _fetchRawString = _asyncToGenerator(function(route, requestBody) {
        var response, responseText, responseJson;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        sendRequest(route, requestBody)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.text()
                    ];
                case 2:
                    responseText = _state.sent();
                    if (!response.ok) {
                        responseJson = JSON.parse(responseText);
                        throw buildCanonicalError(responseJson);
                    }
                    return [
                        2,
                        responseText
                    ];
            }
        });
    });
    return _fetchRawString.apply(this, arguments);
}
// Sends the request using the raw wire format (no mapping) to download a string.
export function fetchRawStringWorker(requestWireFormat, route, requestBody) {
    return _fetchRawStringWorker.apply(this, arguments);
}
function _fetchRawStringWorker() {
    _fetchRawStringWorker = _asyncToGenerator(function(requestWireFormat, route, requestBody) {
        var requestBodyInWireFormat, bodyJson;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    requestBodyInWireFormat = requestWireFormat.toJson(requestBody);
                    bodyJson = requestBodyInWireFormat ? createBodyJson(requestBodyInWireFormat) : "{}";
                    return [
                        4,
                        fetchRawString(route, bodyJson)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _fetchRawStringWorker.apply(this, arguments);
}
// Creates a raw string download function.
export function createRawStringClient(requestWireFormat, route) {
    return function(req) {
        return fetchRawStringWorker(requestWireFormat, route, req);
    };
}
export var CanonicalErrorCode;
(function(CanonicalErrorCode) {
    CanonicalErrorCode[CanonicalErrorCode["OK"] = 0] = "OK";
    CanonicalErrorCode[CanonicalErrorCode["CANCELLED"] = 1] = "CANCELLED";
    CanonicalErrorCode[CanonicalErrorCode["UNKNOWN"] = 2] = "UNKNOWN";
    CanonicalErrorCode[CanonicalErrorCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
    CanonicalErrorCode[CanonicalErrorCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
    CanonicalErrorCode[CanonicalErrorCode["NOT_FOUND"] = 5] = "NOT_FOUND";
    CanonicalErrorCode[CanonicalErrorCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
    CanonicalErrorCode[CanonicalErrorCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
    CanonicalErrorCode[CanonicalErrorCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
    CanonicalErrorCode[CanonicalErrorCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
    CanonicalErrorCode[CanonicalErrorCode["ABORTED"] = 10] = "ABORTED";
    CanonicalErrorCode[CanonicalErrorCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
    CanonicalErrorCode[CanonicalErrorCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
    CanonicalErrorCode[CanonicalErrorCode["INTERNAL"] = 13] = "INTERNAL";
    CanonicalErrorCode[CanonicalErrorCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
    CanonicalErrorCode[CanonicalErrorCode["DATA_LOSS"] = 15] = "DATA_LOSS";
    CanonicalErrorCode[CanonicalErrorCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
})(CanonicalErrorCode || (CanonicalErrorCode = {}));
function getCanonicalErrorFromCode(code) {
    switch(code){
        case CanonicalErrorCode.OK:
            return google.rpc.Code.OK;
        case CanonicalErrorCode.CANCELLED:
            return google.rpc.Code.CANCELLED;
        case CanonicalErrorCode.UNKNOWN:
            return google.rpc.Code.UNKNOWN;
        case CanonicalErrorCode.INVALID_ARGUMENT:
            return google.rpc.Code.INVALID_ARGUMENT;
        case CanonicalErrorCode.DEADLINE_EXCEEDED:
            return google.rpc.Code.DEADLINE_EXCEEDED;
        case CanonicalErrorCode.NOT_FOUND:
            return google.rpc.Code.NOT_FOUND;
        case CanonicalErrorCode.ALREADY_EXISTS:
            return google.rpc.Code.ALREADY_EXISTS;
        case CanonicalErrorCode.PERMISSION_DENIED:
            return google.rpc.Code.PERMISSION_DENIED;
        case CanonicalErrorCode.RESOURCE_EXHAUSTED:
            return google.rpc.Code.RESOURCE_EXHAUSTED;
        case CanonicalErrorCode.FAILED_PRECONDITION:
            return google.rpc.Code.FAILED_PRECONDITION;
        case CanonicalErrorCode.ABORTED:
            return google.rpc.Code.ABORTED;
        case CanonicalErrorCode.OUT_OF_RANGE:
            return google.rpc.Code.OUT_OF_RANGE;
        case CanonicalErrorCode.UNIMPLEMENTED:
            return google.rpc.Code.UNIMPLEMENTED;
        case CanonicalErrorCode.INTERNAL:
            return google.rpc.Code.INTERNAL;
        case CanonicalErrorCode.UNAVAILABLE:
            return google.rpc.Code.UNAVAILABLE;
        case CanonicalErrorCode.DATA_LOSS:
            return google.rpc.Code.DATA_LOSS;
        case CanonicalErrorCode.UNAUTHENTICATED:
            return google.rpc.Code.UNAUTHENTICATED;
        default:
            return google.rpc.Code.INTERNAL;
    }
}
// TODO(b/205733596): We need this (at least temporarily) until we get enums to be
// consistently UPPER_SNAKE_CASE. The new proto3 backend sends error codes in this
// format but the legacy one used integers.
function getCanonicalErrorCodeFromProto3Enum(enumValue) {
    switch(enumValue){
        case "OK":
            return CanonicalErrorCode.OK;
        case "CANCELLED":
            return CanonicalErrorCode.CANCELLED;
        case "UNKNOWN":
            return CanonicalErrorCode.UNKNOWN;
        case "INVALID_ARGUMENT":
            return CanonicalErrorCode.INVALID_ARGUMENT;
        case "DEADLINE_EXCEEDED":
            return CanonicalErrorCode.DEADLINE_EXCEEDED;
        case "NOT_FOUND":
            return CanonicalErrorCode.NOT_FOUND;
        case "ALREADY_EXISTS":
            return CanonicalErrorCode.ALREADY_EXISTS;
        case "PERMISSION_DENIED":
            return CanonicalErrorCode.PERMISSION_DENIED;
        case "RESOURCE_EXHAUSTED":
            return CanonicalErrorCode.RESOURCE_EXHAUSTED;
        case "FAILED_PRECONDITION":
            return CanonicalErrorCode.FAILED_PRECONDITION;
        case "ABORTED":
            return CanonicalErrorCode.ABORTED;
        case "OUT_OF_RANGE":
            return CanonicalErrorCode.OUT_OF_RANGE;
        case "UNIMPLEMENTED":
            return CanonicalErrorCode.UNIMPLEMENTED;
        case "INTERNAL":
            return CanonicalErrorCode.INTERNAL;
        case "UNAVAILABLE":
            return CanonicalErrorCode.UNAVAILABLE;
        case "DATA_LOSS":
            return CanonicalErrorCode.DATA_LOSS;
        case "UNAUTHENTICATED":
            return CanonicalErrorCode.UNAUTHENTICATED;
        default:
            return CanonicalErrorCode.INTERNAL;
    }
}
export var CanonicalError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(CanonicalError, Error1);
    var _super = _createSuper(CanonicalError);
    function CanonicalError(message, code) {
        var details = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined, rawResponse = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined;
        _classCallCheck(this, CanonicalError);
        var _this;
        _this = _super.call(this, message);
        // Used for type checking since 'instanceof' does not work.
        _this.isCanonicalError = true;
        /*
      A breaking change in TypeScript occured that means extending 
      from certain classes (like Error) no longer works with certain
      compiler outputs. In some cases this code will run, but the
      returned object will be an Error instead of a CanoicalError.

      If we manually set the prototype, then the methods will at
      least still be available everywhere, though `instanceof` 
      won't work correctly, so duck-typing will be necessary if
      you want to check the type
     */ Object.setPrototypeOf(_assertThisInitialized(_this), CanonicalError.prototype);
        _this.code = code;
        _this.status = getCanonicalErrorFromCode(code);
        _this.details = details;
        _this.rawResponse = rawResponse;
        return _this;
    }
    var _proto = CanonicalError.prototype;
    _proto.getErrorInfos = function getErrorInfos() {
        var _details;
        return ((_details = this.details) !== null && _details !== void 0 ? _details : []).filter(function(errorDetail) {
            return errorDetail && "@type" in errorDetail && errorDetail["@type"] === "type.googleapis.com/google.rpc.ErrorInfo";
        }).map(function(errorDetail) {
            return new ErrorInfo(errorDetail.reason || "", errorDetail.domain || "", errorDetail.metadata || {});
        });
    };
    // Returns first ErrorInfo with matching reason code, or undefined if none match.
    _proto.findReason = function findReason(reason) {
        return this.getErrorInfos().filter(function(info) {
            return info.hasReason(reason);
        })[0];
    };
    _proto.hasReason = function hasReason(reason) {
        return this.findReason(reason) !== undefined;
    };
    return CanonicalError;
}(_wrapNativeSuper(Error));
// 'e instanceof CanonicalError' does not work (see constructor comment) so expose
// this official Typescript workaround, using a special identifying field.
export function isCanonicalError(err) {
    return err.isCanonicalError === true;
}
var ErrorInfo = /*#__PURE__*/ function() {
    "use strict";
    function ErrorInfo(reason, domain, metadata) {
        _classCallCheck(this, ErrorInfo);
        this.reason = reason;
        this.domain = domain;
        this.metadata = metadata;
    }
    var _proto = ErrorInfo.prototype;
    _proto.hasReason = function hasReason(reason) {
        // TODO(b/243797014): Use direct equality check when they match correctly.
        return equalsCaseInsensitive(this.reason, reason);
    };
    return ErrorInfo;
}();
// Proto3 helpers. Move to a different file?
export function durationToJsonString(duration) {
    if (!duration) {
        return "";
    }
    var totalSeconds = duration.seconds;
    if (duration.nanos) {
        totalSeconds = totalSeconds + duration.nanos / 1000000000;
    }
    return "".concat(totalSeconds, "s");
}
export function jsonStringToDuration(durationString) {
    if (!durationString) {
        return {
            seconds: 0,
            nanos: 0
        };
    }
    var totalSeconds = parseFloat(durationString);
    var wholeSeconds = Math.trunc(totalSeconds);
    var fractionalSeconds = totalSeconds - wholeSeconds;
    return {
        seconds: wholeSeconds,
        nanos: Math.round(fractionalSeconds * 1000000000)
    };
}
